import { render, staticRenderFns } from "./BalancesPlanForm.vue?vue&type=template&id=b28ad492&scoped=true&"
import script from "./BalancesPlanForm.vue?vue&type=script&lang=js&"
export * from "./BalancesPlanForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28ad492",
  null
  
)

export default component.exports